import React, { Fragment } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
// import { Dashboard } from "./pages/Dashboard";
import { Dashboard } from "./pages/Dashboard";
import { UserActivityDashboard } from "./pages/UserActivityDashboard";
import { EditPrompts } from "./pages/EditPrompts";
import { CreateReport } from "./pages/CreateReport";
import { Home } from "./pages/Home";
import { ReportGen } from "./pages/ReportGen";
import { OutlineEditor } from "./pages/OutlineEditor";
import { Logout } from "./pages/Logout";

// import { Hero404 } from "./pages/Hero404";
// import { Profile } from "./pages/Profile";

const CaurisRoutes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/chat" component={Dashboard} />
        <Route path="/logout" component={Logout} />
        <Route path="/editPrompts" component={EditPrompts} />
        <Route path="/createReport" component={CreateReport} />
        <Route path="/ReportGen" component={ReportGen} />
        <Route path="/outlineEditor" component={OutlineEditor} />
        <Route path="/jam" component={ReportGen} />
        <Route path="/userActivity" component={UserActivityDashboard} />
      </Switch>
    </BrowserRouter>
  );
};

export default CaurisRoutes;
